export const services = {
  seo: {
    title: '服務項目 | LensBank 專業器材租賃',
    description: '提供專業器材租賃、台日拍攝協作、日本剪輯調光、Urent 寄租服務。一站式影像創作解決方案，滿足您的所有拍攝需求。',
    keywords: '器材租賃,台日拍攝,剪輯調光,寄租服務,影像製作'
  },
  hero: {
    title: '服務項目',
    subtitle: '一站式影像創作解決方案'
  },
  equipment: {
    title: '專業器材租賃',
    subtitle: '超過 1,000+ 件專業攝影器材',
    desc: '提供相機、鏡頭、燈光、收音、監看、穩定器等全方位專業器材租賃服務。所有器材定期保養維護，確保最佳使用狀態。',
    features: [
      '多品牌選擇：Canon、Sony、RED、ARRI 等',
      '彈性租期：日租、週租、月租',
      '專業諮詢：協助選擇最適合的器材組合',
      '技術支援：提供使用教學與故障排除',
      '保險服務：完善的器材保險方案（日本限定）'
    ]
  },
  japanRental: {
    sectionLabel: '日本器材租賃服務',
    title: '日本器材租賃服務',
    content: 'LensBank 作為值得信賴的合作夥伴，誠摯推薦位於東京的 TREE Digital Studio Inc. 旗下的攝影器材租賃部門「CRANK」。\n\nTREE Digital Studio Inc. 擁有能以中文溝通的工作人員，能夠協助來自台灣的拍攝團隊順利進行各項聯繫與交流。也可選擇直接聯繫 TREE Digital Studio Inc.（CRANK）。我們尊重每位客戶的需求與情況，您可以彈性選擇最合適的合作方式。',
    learnMore: '了解更多',
    priceNote: '日本器材租賃，需以日本官方報價為主。台灣提供各項配套服務。'
  },
  portfolio: {
    title: '器材協力',
    subtitle: '精選作品集',
    desc: '我們的器材參與了眾多優秀影視作品的拍攝，以下是部分合作案例精選。',
    viewAll: '查看更多作品'
  },
  crew: {
    subtitle: '專業團隊',
    title: '專業人員出班案例',
    desc: '我們的專業攝影團隊為各類型專案提供出班服務，從廣告拍攝到紀錄片製作',
    viewAll: '查看更多出班作品'
  },
  taiwanJapan: {
    hero: {
      title: '台日拍攝製作服務',
      description: '提供台灣與日本之間的跨境拍攝協作服務，包括器材租賃、攝影團隊、場地協調、行政支援等一站式解決方案。'
    },
    features: {
      title: '服務特色',
      equipment: {
        title: '器材跨境調度',
        description: '提供台日兩地專業器材租賃與跨境運送服務，確保拍攝器材準時到位。'
      },
      team: {
        title: '當地攝影團隊',
        description: '配置經驗豐富的當地攝影團隊，熟悉在地拍攝環境與文化。'
      },
      logistics: {
        title: '場地與行政調整',
        description: '協助場地勘景、拍攝許可申請、行政流程處理等繁瑣事務。'
      },
      support: {
        title: '全程支援服務',
        description: '提供翻譯、溝通協調、後勤支援等全方位服務，確保拍攝順利進行。'
      }
    },
    process: {
      title: '服務流程',
      step1: {
        title: '需求諮詢',
        description: '了解您的拍攝需求、預算與時程安排。'
      },
      step2: {
        title: '方案規劃',
        description: '提供完整的拍攝方案，包括器材、團隊、場地建議。'
      },
      step3: {
        title: '執行準備',
        description: '協調所有資源，處理行政流程，確保萬事俱備。'
      },
      step4: {
        title: '拍攝支援',
        description: '現場全程支援，確保拍攝順利完成。'
      }
    },
    form: {
      title: '立即預約諮詢',
      description: '填寫以下表單，我們將盡快與您聯繫',
      location: {
        label: '拍攝地點',
        placeholder: '請選擇拍攝地點',
        taiwan: '台灣',
        japan: '日本',
        other: '其他'
      },
      city: {
        label: '城市',
        placeholder: '請輸入城市名稱'
      },
      dateRange: {
        start: '預計開始日期',
        end: '預計結束日期'
      },
      needTypes: {
        label: '需求項目',
        equipment: '器材租賃',
        photographer: '攝影師',
        lighting: '燈光師',
        sound: '錄音師',
        dit: 'DIT',
        other: '其他'
      },
      budget: {
        label: '預算範圍',
        placeholder: '請選擇預算範圍',
        range1: 'NT$ 50,000 以下',
        range2: 'NT$ 50,000 - 100,000',
        range3: 'NT$ 100,000 - 300,000',
        range4: 'NT$ 300,000 - 500,000',
        range5: 'NT$ 500,000 以上',
        negotiable: '面議'
      },
      company: {
        label: '公司名稱',
        placeholder: '請輸入公司名稱（選填）'
      },
      name: {
        label: '聯絡人姓名',
        placeholder: '請輸入您的姓名'
      },
      email: {
        label: '電子信箱',
        placeholder: '請輸入您的電子信箱'
      },
      phone: {
        label: '聯絡電話',
        placeholder: '請輸入您的聯絡電話'
      },
      projectDescription: {
        label: '專案說明',
        placeholder: '請簡述您的拍攝專案內容、需求與特殊要求...'
      },
      attachments: {
        label: '附件上傳',
        description: '可上傳腳本、分鏡表、參考資料等（選填）'
      },
      submit: '送出諮詢',
      submitting: '送出中...',
      success: '感謝您的諮詢！我們將盡快與您聯繫。',
      error: '送出失敗，請稍後再試或直接聯繫我們。'
    }
  },
  postProduction: {
    hero: {
      title: '日本剪輯調光服務',
      description: '與日本頂尖後製團隊合作,提供專業的剪輯、調光、特效與聲音後製服務。適合高端廣告、品牌形象影片、電影等需要頂級品質的專案。'
    },
    viewWorks: '查看參考作品',
    features: {
      title: '服務特色',
      quality: {
        title: '頂級品質',
        description: '日本廣告等級的後製水準,精準掌握每個細節,呈現最佳視覺效果。'
      },
      experience: {
        title: '豐富經驗',
        description: '團隊擁有豐富的廣告、電影、MV製作經驗,熟悉各種風格與需求。'
      },
      equipment: {
        title: '專業設備',
        description: '使用 DaVinci Resolve、Avid、Pro Tools 等業界標準軟硬體設備。'
      },
      communication: {
        title: '雙語溝通',
        description: '提供中日雙語溝通服務,確保需求精準傳達,協作順暢無礙。'
      }
    },
    services: {
      title: '服務項目',
      editing: {
        title: '專業剪輯',
        items: [
          '廣告剪輯',
          '品牌形象影片',
          '紀錄片剪輯',
          '音樂錄影帶',
          '企業宣傳片'
        ]
      },
      grading: {
        title: '專業調光',
        items: [
          'DaVinci Resolve 調光',
          '電影級色彩管理',
          '風格化調色',
          'HDR 調光',
          'LUT 客製化'
        ]
      },
      vfx: {
        title: '視覺特效',
        items: [
          '合成特效',
          '動態圖形',
          '去背合成',
          '場景延伸',
          '特效修復'
        ]
      },
      sound: {
        title: '聲音後製',
        items: [
          '聲音設計',
          '配音錄製',
          '音樂混音',
          '環境音處理',
          '杜比全景聲'
        ]
      }
    },
    process: {
      title: '製作流程',
      step1: {
        title: '需求討論',
        description: '了解專案需求、風格方向、預算與時程,提供專業建議與報價。'
      },
      step2: {
        title: '素材交付',
        description: '透過雲端傳輸原始素材,確認檔案格式、色彩空間等技術規格。'
      },
      step3: {
        title: '製作審片',
        description: '進行剪輯、調光、特效製作,透過線上審片系統即時溝通修改。'
      },
      step4: {
        title: '完成交付',
        description: '最終版本交付,提供多種格式檔案,並提供專案存檔服務。'
      }
    },
    form: {
      title: '立即預約諮詢',
      description: '填寫以下表單，我們將盡快與您聯繫',
      serviceType: {
        label: '需求服務',
        editing: '剪輯',
        grading: '調光',
        vfx: '視覺特效',
        sound: '聲音後製',
        package: '整合服務'
      },
      projectType: {
        label: '專案類型',
        placeholder: '請選擇專案類型',
        commercial: '廣告',
        brand: '品牌形象',
        mv: '音樂錄影帶',
        documentary: '紀錄片',
        film: '電影/短片',
        other: '其他'
      },
      duration: {
        label: '影片長度(秒)',
        placeholder: '例:30'
      },
      deadline: {
        label: '期望完成日期'
      },
      budget: {
        label: '預算範圍',
        placeholder: '請選擇預算範圍',
        range1: 'NT$ 30,000 以下',
        range2: 'NT$ 30,000 - 80,000',
        range3: 'NT$ 80,000 - 150,000',
        range4: 'NT$ 150,000 - 300,000',
        range5: 'NT$ 300,000 以上',
        negotiable: '面議'
      },
      company: {
        label: '公司名稱',
        placeholder: '請輸入公司名稱(選填)'
      },
      name: {
        label: '聯絡人姓名',
        placeholder: '請輸入您的姓名'
      },
      email: {
        label: '電子信箱',
        placeholder: '請輸入您的電子信箱'
      },
      phone: {
        label: '聯絡電話',
        placeholder: '請輸入您的聯絡電話'
      },
      reference: {
        label: '參考影片連結',
        placeholder: '提供 YouTube、Vimeo 等影片連結(選填)'
      },
      projectDescription: {
        label: '專案說明',
        placeholder: '簡述專案內容、風格需求、特殊要求...'
      },
      submit: '送出諮詢',
      submitting: '送出中...',
      success: '感謝您的諮詢!我們將盡快與您聯繫。',
      error: '送出失敗，請稍後再試或直接聯繫我們。'
    }
  },
  urent: {
    hero: {
      title: 'Urent 寄租服務',
      description: '將您的閒置攝影器材寄放在 LensBank，由我們負責保管、維護與租賃管理，您只需坐享分潤收益。'
    },
    features: {
      title: '服務特色',
      income: {
        title: '被動收入',
        description: '器材閒置時也能創造收益，投資持續回報。'
      },
      management: {
        title: '專業管理',
        description: '恆溫恆濕保管環境，定期維護保養，確保最佳狀態。'
      },
      insurance: {
        title: '保險保障',
        description: '完整的器材保險，租賃期間損壞由平台負責。'
      },
      transparent: {
        title: '透明分潤',
        description: '清楚的分潤機制，每月定期結算撥款。'
      }
    },
    howItWorks: {
      title: '寄託流程',
      step1: {
        title: '提交申請',
        description: '填寫器材資訊、上傳照片，提供購買證明與配件清單。'
      },
      step2: {
        title: '評估審核',
        description: '我們評估器材狀況、市場需求與租賃價值。'
      },
      step3: {
        title: '簽訂合約',
        description: '確認分潤比例、保管條款與保險內容。'
      },
      step4: {
        title: '開始寄託',
        description: '器材上架出租，開始創造被動收益。'
      }
    },
    revenue: {
      title: '收益分配',
      description: '透明公開的分潤機制，讓器材的最大價值被創造',
      owner: '器材擁有者',
      platform: '平台管理費',
      note: '* 實際分潤比例依器材類型與市場需求調整'
    },
    requirements: {
      title: '寄託條件',
      item1: '器材需為正常可使用狀態，無重大瑕疵或故障',
      item2: '提供完整配件（電池、充電器、原廠包裝等）',
      item3: '提供購買證明或發票（確保器材來源合法）',
      item4: '器材市場價值需達 NT$ 30,000 以上',
      item5: '同意簽署寄託合約與保險條款'
    },
    form: {
      title: '立即申請寄託',
      description: '填寫以下表單，我們將盡快與您聯繫',
      equipmentName: {
        label: '器材名稱',
        placeholder: '例：Canon EOS R5、Sony FX3'
      },
      category: {
        label: '器材類別',
        placeholder: '請選擇類別',
        camera: '相機',
        lens: '鏡頭',
        lighting: '燈光',
        sound: '收音',
        monitor: '監看',
        stabilizer: '穩定器',
        other: '其他'
      },
      brand: {
        label: '品牌',
        placeholder: '例：Canon、Sony、RED'
      },
      purchaseDate: {
        label: '購買日期'
      },
      condition: {
        label: '器材狀況',
        new: '全新未使用',
        excellent: '極佳（9成新以上）',
        good: '良好（7-8成新）',
        fair: '尚可（5-6成新）'
      },
      accessories: {
        label: '配件清單',
        placeholder: '詳列所有配件，例：原廠電池x2、充電器、原廠包裝盒、說明書...'
      },
      rentalPeriod: {
        label: '期望租期長度',
        placeholder: '請選擇租期長度',
        threeMonths: '3 個月',
        sixMonths: '6 個月',
        oneYear: '1 年',
        twoYears: '2 年',
        threeYears: '3 年'
      },
      photos: {
        label: '器材照片',
        description: '上傳正面、側面、背面、配件等清晰照片（至少 3 張）'
      },
      name: {
        label: '聯絡人姓名',
        placeholder: '請輸入您的姓名'
      },
      email: {
        label: '電子信箱',
        placeholder: '請輸入您的電子信箱'
      },
      phone: {
        label: '聯絡電話',
        placeholder: '請輸入您的聯絡電話'
      },
      notes: {
        label: '備註說明',
        placeholder: '其他想補充的資訊...'
      },
      agreement: {
        label: '我已閱讀並同意',
        terms: '寄租服務條款'
      },
      disclaimer: '我方保留最後審議權。',
      submit: '送出申請',
      submitting: '送出中...',
      success: '感謝您的申請！我們將盡快與您聯繫。',
      error: '送出失敗，請稍後再試或直接聯繫我們。'
    },
    title: 'Urent 寄租服務',
    subtitle: '讓閒置器材創造價值',
    desc: '將您的閒置攝影器材寄放在 LensBank，由我們負責保管、維護與租賃管理，您只需坐享分潤收益。',
    highlights: [
      '專業保管：恆溫恆濕的儲存環境',
      '定期維護：專業團隊定期檢查保養',
      '保險保障：完善的器材保險',
      '透明分潤：清楚的收益分配機制',
      '彈性取回：隨時可取回自己的機材'
    ],
    process: {
      title: '寄託流程',
      steps: [
        {
          title: '申請提交',
          desc: '填寫器材資訊與照片'
        },
        {
          title: '評估審核',
          desc: '器材狀況與市場需求評估'
        },
        {
          title: '簽訂合約',
          desc: '分潤比例與保管條款確認'
        },
        {
          title: '開始寄託',
          desc: '上架後開始創造收益'
        }
      ]
    }
  },
  cta: {
    title: '準備開始您的專案？',
    subtitle: '立即聯繫我們，讓專業團隊協助您實現創意',
    button: '立即諮詢'
  }
};